var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarTimeTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0.166626 0.166748H1.33329V10.6667H11.8333V11.8334H0.166626V0.166748ZM3.08329 4.83342H8.91663V6.58342H3.08329V4.83342ZM5.41663 7.75008H11.25V9.50008H5.41663V7.75008ZM2.49996 1.33341H11.8333V3.66675H10.6666V2.50008H3.66663V3.66675H2.49996V1.33341Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarTimeTracker);
export default __webpack_public_path__ + "static/media/navbar-time-tracker.9aa8ffc1.svg";
export { ForwardRef as ReactComponent };